import styled from 'styled-components'

export const SpinnerWithText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

export const Spinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top: 3px solid ${({ theme }) => theme.accentActive};
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const SortingOverlay = styled.div`
  position: absolute;
  top: 58px;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => `${theme.cardSecondary}`};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
`

export const DataTransitionOverlay = styled(SortingOverlay)`
  background-color: ${({ theme }) => theme.cardPrimary};
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.9;
    }
  }
`
